var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrendingUp = function SvgTrendingUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trending_up",
    clipPath: "url(#clip0_3403_2623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0417 5.70833L15.2417 6.90833L11.1751 10.975L8.4334 8.23333C8.1084 7.90833 7.5834 7.90833 7.2584 8.23333L2.2584 13.2417C1.9334 13.5667 1.9334 14.0917 2.2584 14.4167C2.5834 14.7417 3.1084 14.7417 3.4334 14.4167L7.84173 10L10.5834 12.7417C10.9084 13.0667 11.4334 13.0667 11.7584 12.7417L16.4167 8.09167L17.6167 9.29167C17.8751 9.55 18.3251 9.36667 18.3251 9V5.41667C18.3334 5.18333 18.1501 5 17.9167 5H14.3417C13.9667 5 13.7834 5.45 14.0417 5.70833Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3403_2623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrendingUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trending_up.b013d5ac.svg";
export { ForwardRef as ReactComponent };